module.exports = __webpack_public_path__ + "media/images/android_platform-ed931b968cef640bce83900344b91bd5.png";